/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { buildUrl } from "@/utils/bindUrl";
import { IResponseListScope, IResponseShowScope, IScope } from "@/interfaces/scopes";

export class ScopeAPI {
  // Reutiliza a instância global, sem constructor/baseUrl/interceptors
  private api = api;

  async listScopes({ filter, includes, page, limit }: IListParams) {
    const params = qs.stringify({ filter, includes, page, limit });
    const endPoint = `/scopes?${params}`;
    const { data } = await this.api.get<IResponseListScope>(endPoint);
    return data;
  }

  async showScope({
    id,
    includes,
  }: { id: string | number } & Partial<IListParams>) {
    const params = qs.stringify({ includes });
    const endPoint = buildUrl("/scopes/{id}?{params}", { id, params });
    const { data } = await this.api.get<IResponseShowScope>(endPoint);
    return data;
  }

  async createScope({ scope }: { scope: IScope }) {
    const endPoint = "/scopes";
    const { data } = await this.api.post<IResponseShowScope>(endPoint, {
      scope,
    });
    return data;
  }

  async updateScope({ id, scope }: { id: string | number; scope: IScope }) {
    const endPoint = buildUrl("/scopes/{id}", { id });
    const { data } = await this.api.put<IResponseShowScope>(endPoint, {
      scope,
    });
    return data;
  }
}
